import { Component, Input } from '@angular/core';
import { ListModel } from './list.model';

@Component({
  selector: 'lib-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class ListComponent {
  @Input() set inputList(data: any[]) {
    this.items = data.map((item) => new ListModel(item));
  }

  items: ListModel[];

  constructor() {
  }
}
